import * as React from "react";

import { LoginModal } from "@work/containers/Login";

export const HeaderModals = (): React.ReactElement => (
  <React.Fragment>
    <LoginModal />
  </React.Fragment>
);
